export default function toFixedFloat(amount) {
  if (amount) {
    return parseFloat(amount).toString().includes(".") ? parseFloat(amount).toFixed(2) : parseFloat(parseFloat(amount).toFixed(2))
  }
  return amount;
}
